import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Box } from "@mui/material";

const AnimatedSection = ({ children, sx = {}, id, delay = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px 0px" });

  return (
    <Box
      component="section"
      id={id}
      ref={ref}
      sx={{ position: "relative", ...sx }}
    >
      <motion.div
        initial={{ opacity: 0, y: 36 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }}
      >
        {children}
      </motion.div>
    </Box>
  );
};

export default AnimatedSection;
